import { defineFetch } from 'resift';

interface BatchAction {
  type: 'create' | 'destroy';
  id: string; // Entity Id
  data?: {
    exclude: boolean; // "true" if adding to the exclusion list, "false" if adding to the inclusion list; if none passed, will return both manually excluded and included entities
  };
}

const makeUpdatePermissionScopedEntities = defineFetch({
  displayName: 'Update Permission Scoped Entities',
  make: (roleId: string, permissionId: string) => ({
    request: (actions: BatchAction[]) => ({ http }) =>
      http({
        method: 'PUT',
        route: `/roles/${roleId}/permissions/${permissionId}/scoped-entities`,
        data: { actions },
      }),
  }),
});

export default makeUpdatePermissionScopedEntities;
